import "bootstrap/dist/css/bootstrap.min.css";
// import 'jquery/dist/jquery.min.js'
// import "bootstrap/dist/js/bootstrap.min.js";
// import "@popperjs/core/dist/umd/popper.min.js";

import "./src/styles/styles.scss"
import React from 'react'
import SimpleReactLightbox from 'simple-react-lightbox'
import { ContextProvider } from './src/showcase/shopifyManager'

// eslint-disable-next-line react/prop-types
export const wrapRootElement = ({ element }) => (
  <ContextProvider>
    <SimpleReactLightbox>{element}</SimpleReactLightbox>
  </ContextProvider>
)

export const shouldUpdateScroll = ({ routerProps }) => {
  const hasAnchor = !!routerProps.location.hash; // (ie. /#features)

  return hasAnchor
}
